import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import DetailInfoComponent from "../../../components/detailInfo/detailInfoComponent";
import { SectionModel } from "../../../models/components.model";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";
import { DocumentUrl, Income } from "../../../models/cartable.model";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";
import DivisionIdentityCmp from "../../../components/cards/DivisionIdentityCmp";
import DetailInfoVehicle from "../../../components/detailInfo/detailInfoVehicle";

function _VehicleDocuments({ data, documentList, withoutDoc, title }: any) {
    let sections: SectionModel[];
    sections = [
        { dataKey: "vin", rowCol: 3, title: "شماره شاسی" },
        { dataKey: "motorNumber", rowCol: 3, title: "شماره موتور" },
        { dataKey: "vehicleTypeTitle", rowCol: 3, title: "نوع خودرو" },
        { dataKey: "model", rowCol: 3, title: "مدل خودرو", },
        { dataKey: "productionYear", rowCol: 3, title: "سال ساخت خودرو" },
        { dataKey: "kilometer", rowCol: 3, title: " کارکرد خودرو" },
        { dataKey: "pelak", rowCol: 3, title: " پلاک خودرو" },
        { dataKey: "color", rowCol: 3, title: " رنگ خودرو" },
        {
            dataKey: "insuranceAmount", rowCol: 3, title: "مبلغ بیمه تا پایان دوره تسهیلات", dataPostValue: "ریال",
            hasThousandSeparatorFormat: true,
        },
        { dataKey: "description", rowCol: 9, title: "توضیحات" },
    ];

    return (
        <DetailInfoComponentThumbnail
            sections={sections}
            data={data}
            // documentList={data.documents}
            // title={true}
            height={"20vh"}
            showFooter={false}
            showDoc={withoutDoc}
            isGuarantor={true}
        />
    );
}
function _BasicDocuments({ documentList, title, withoutDoc }: any) {
    return (
        <DetailInfoVehicle
            documentList={documentList}
            title={true}
            height={"20vh"}
            showFooter={false}
            showDoc={withoutDoc} sections={[]} data={undefined}
            isGuarantor={true}
        />
    );
}
export default function VehicleDocuments(props: any) {
    return (
        <>

            <DivisionCmp
                child={
                    <_VehicleDocuments
                        data={props.data}
                        documentList={props.data.documents}
                        withoutDoc={props.withoutDoc}
                    />
                } title={"مشخصات خودرو"}>
            </DivisionCmp>
            {props.showDocuments == true ? <DivisionCmp
                child={
                    <_BasicDocuments
                        data={props.data}
                        documentList={props.data.documents}
                        withoutDoc={props.withoutDoc}
                    />
                } title={"مدارک اولیه"}></DivisionCmp> : <></>}
        </>
    );
}
